import { render, staticRenderFns } from "./02_Spritzverfugung.vue?vue&type=template&id=c648abf0&"
import script from "./02_Spritzverfugung.vue?vue&type=script&lang=js&"
export * from "./02_Spritzverfugung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports